// @ts-check
import React from 'react';
import { Modal, ModalHeader } from 'preferral-ui/components/Modal';
import { RejectReferralForm } from './RejectReferralForm';

/** @typedef {{
  referralId: string;
  isOpen: boolean;
  onClose(): void;
  onSuccess(): void;
}} RejectReferralModalProps */

/** @type { React.FC<RejectReferralModalProps> } */
export const RejectReferralModal = (props) => {
  const { referralId, isOpen, onClose, onSuccess } = props;

  function handleSuccess() {
    onSuccess();
    onClose();
  }

  return (
    <Modal
      className="_RejectReferralModal"
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <ModalHeader icon="times" title="Reject Referral" onClose={onClose} />

      <div className="p-4">
        <RejectReferralForm referralId={referralId} onSuccess={handleSuccess} />
      </div>
    </Modal>
  );
};
